var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTickIcon = function SvgTickIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512pt",
    height: "512pt",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 12.801c-134.14 0-243.2 109.05-243.2 243.2s109.05 243.2 243.2 243.2 243.2-109.05 243.2-243.2-109.05-243.2-243.2-243.2zm108.03 203.77L251.9 337.401c-5.633 6.144-13.824 9.727-22.527 9.727s-16.383-3.586-22.527-9.727l-58.879-64c-11.266-12.289-10.754-31.742 1.535-43.52 12.29-11.266 31.742-10.754 43.52 1.535l36.863 39.426 89.602-96.77c11.777-12.289 30.72-12.8 43.52-1.535 11.777 12.289 12.801 31.746 1.024 44.031z",
    fill: "#fff"
  })));
};
export default SvgTickIcon;